import { createFileRoute } from '@tanstack/react-router';
import { RenegociacaoEdicao } from '@/features/renegociacao/page/edicao/RenegociacaoEdicao';

function Component() {
    return <RenegociacaoEdicao isPagar={false} />;
}

export const Route = createFileRoute('/a/renegociacao/contas-receber/cadastrar')({
    component: Component,
});
